'use client'

import * as React from 'react'
import { cn } from '../../utils/cn'

interface ContainerProps {
  children: React.ReactNode
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

const sizeClasses = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-6xl',
  xl: 'max-w-7xl',
}

export function Container({
  children,
  className,
  size = 'lg'
}: ContainerProps) {
  return (
    <div
      className={cn(
        'landing-container',
        sizeClasses[size],
        className
      )}
    >
      {children}
    </div>
  )
}
